import type { Prototype } from "../prototype-types";

export const justinLiPrototypes: Prototype[] = [
  {
    id: "jli-insider-messenger-upsell",
    name: "Insider Messenger Upsell",
    path: "/jli/insider-messenger-upsell",
    description:
      "Compares outside-the-thread, dedicated promo thread, and guided Insider offer concepts with personalization, suppression, and dismissal controls.",
    owner: "Justin Li",
    createdAt: "2026-08-17",
    lastUpdated: "2026-08-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/jli-insider-messenger-upsell.png",
    creationTool: "cursor",
  },
  {
    id: "jli-pos-messenger-upsell",
    name: "POS Messenger Upsell",
    path: "/jli/pos-messenger-upsell",
    description:
      "Shows the POS upsell in Messenger with copy variants A and B, the variant A intro options, and detected POS states.",
    owner: "Justin Li",
    createdAt: "2026-11-04",
    lastUpdated: "2026-11-04",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/jli-pos-messenger-upsell.png",
    creationTool: "cursor",
  },
];
